import Layout from './layout.vue'
export default Layout



// WEBPACK FOOTER //
// ./src/view/layout/index.js